import { GridBlockType } from 'services/entities/BlockTypes';
import type {
  BlocksFromSectionsByDocumentIdApiResponse,
  DocumentSectionsResponse,
  SectionByDocumentIdApiResponse,
} from 'services/documents/DocumentRepository';
import { assertCrmRowMarkersValid } from 'components/editor/grid/reduxStore/table.types';

export const getTableBlocks = (sectionsResponse: DocumentSectionsResponse): BlocksFromSectionsByDocumentIdApiResponse[][] | undefined => {
  if (!sectionsResponse.sections || !Array.isArray(sectionsResponse.sections)) {
    return undefined;
  }

  const tableBlocksBySection = sectionsResponse.sections
    .map((section: SectionByDocumentIdApiResponse) => {
      const tableBlocksInSection = section.blocks.filter((block) => block.type === GridBlockType.TABLE);
      return tableBlocksInSection.length > 0 ? tableBlocksInSection : undefined;
    })
    .filter((blocks) => blocks !== undefined) as BlocksFromSectionsByDocumentIdApiResponse[][];

  tableBlocksBySection.forEach((blocks) => blocks.forEach((block) => block.content && assertCrmRowMarkersValid(block.content.rows)));

  return tableBlocksBySection;
};
